import { DataObject } from '@shared/models/data-object.model';
import { OverlayService } from '@miq/stacking-plan';
import { XColumn } from '@records/catalog/extension.model';
import { showOverlay } from '@records/controls/custom/common/availablity-agreement-date/availability-agreement-date.component';
import { RoleTypes } from '@shared/models/role-types';
import { hasAgreementColumn } from '@records/records-search/records-details/record-detail-container/custom-entity-details/common/select-company/select-company.const';
import { Position } from './complex-table.model';

export enum HandleType {
  OVERLAY_TYPE = 'Overlay',
  HANDLE_TYPE = 'Handle',
}

export type ColumnComplexTable = Pick<XColumn, 'unit' | 'editable' | 'columnId' | 'subscribeOn' | 'lookupCategory'> & {
  clickHandler: ComplexColumnDataHandler;
  disableDisplay?: boolean;
  height?: string;
  showHandler?: boolean;
  field?: string;
};

export interface OverlayObject {
  overlayService: OverlayService;
  event: MouseEvent;
  row: DataObject;
}

export interface ComplexColumnDataHandler {
  position: string;
  handlerType: string;
  svgIcon?: string;
  condition?: (row: DataObject, columns: ColumnComplexTable[], columnComplex?: ColumnComplexTable) => boolean;
  handle?: (ctx: DataObject | OverlayObject) => void;
  toolTip?: string;
  icon?: string;
  text?: string;
  displayValue?: boolean;
}
export interface ComplexColumnHandler {
  [key: number]: ColumnComplexTable;
}

export const COMPLEX_TABLE_COLUMNS_EXTEND: ComplexColumnHandler = {
  /* AVAILABILITY */
  516: {
    // Company Role
    clickHandler: {
      position: Position.AFTER,
      svgIcon: 'agreement',
      handlerType: 'Overlay',
      condition: (row: DataObject, columns: ColumnComplexTable[]) =>
        hasAgreementColumn(columns) && row.role_desc === RoleTypes.LISTING_REP,
      handle: (ctx: OverlayObject) => showOverlay(ctx.overlayService, ctx.event, ctx.row),
    },
  },
};
